var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"button",class:_vm.classes,attrs:{"to":_vm.to,"href":_vm.href,"data-eventcategory":_vm.eventCategory,"data-eventlabel":_vm.eventLabel},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }